import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';

import { Observable } from 'rxjs';
import { ActivityMailRequest, Response } from '@core/api';

@Injectable({
  providedIn: 'root'
})
export class ActivityMailService {
  constructor(private http: HttpClient) { }

  insert(request: ActivityMailRequest): Observable<Response<any>> {
    return this.http.post<Response<any>>(environment.apiUrl + '/api/ActivityMail/Insert', request);
  }
}
